import { PageLoadEvent } from '../../../types/events';
import { Ecommerce } from '../../../types/datalayer/pageview';
import { PageViewEvent } from '../../../types/datalayer/pageview';

export default (pageload: PageLoadEvent): PageViewEvent => {
  const search = pageload.detail?.search || {};
  const productIds = search.productIds || [];
  const impressions = productIds.map((id, i) => ({
    position: i + 1,
    id: id,
    list: 'Grid Newsletter',
  }));
  const ecommerce: Ecommerce = {
    currencyCode: 'BRL',
    impressions,
  };

  return {
    ecommerce,
  } as PageViewEvent;
};
